import { useInitializeTracking } from "src/analytics/hooks/use-initialize-tracking";
import { initGlobals } from "src/constants/globals";
import { useEmailNewsletterLink } from "src/hooks/use-email-newsletter-link";
import { setUser } from "src/stores/user-store";
import { IBasePageProps } from "src/types/layout";
import { useDisclaimerCheck } from "./use-disclaimer-check";

// This hook initializes main functionality of the app
export function useInitApp(pageProps: IBasePageProps<unknown, unknown>) {
    useDisclaimerCheck(pageProps.global?.disclaimer);
    initGlobals(pageProps.global);
    // Dev-Note: we don't use the user store via hook directly here, because that would lead to an unnecessary re-render
    setUser(pageProps.user);
    useInitializeTracking({ global: pageProps.global, data: pageProps.data });
    useEmailNewsletterLink(pageProps.user!);
}
